import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const ProductFormYup = yupResolver<any>(
  yup
    .object({
      status: yup.string().required(),
    })
    .required(),
);
